import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Cookies from "js-cookie";
import MicButton from "./MicButton";

function ScratchPadSessionPopup({
  show,
  handleClose,
  title,
  button,
  sideConvoList = [],
  apiUrl,
  scratchPadId,
  loginUserID,
  apiToken,
  scratchTitle,
  onSessionCreated,
}) {
  const [sessionName, setSessionName] = useState(null);
  const [sessionType, setSessionType] = useState("side");
  const [selectedSideConvo, setSelectedSideConvo] = useState("");
  const [customInstructions, setCustomInstructions] = useState("");
  const [error, setError] = useState("");
  const [buttonDisable, setButtonDisable] = useState(false);

  useEffect(() => {
    if (show) {
      setSessionName(scratchTitle || "");
      setSessionType("side");
      setSelectedSideConvo("");
      setCustomInstructions("");
      setError("");
    } else {
      setSessionName("");
      setSessionType("side");
      setSelectedSideConvo("");
      setCustomInstructions("");
    }
  }, [show, scratchTitle]);

  const handleSubmit = () => {
    if (!sessionName || !sessionName.trim()) {
      setError("Topic name is required");
      return;
    }
    if (sessionType === "child" && !selectedSideConvo) {
      setError("Please select a Topic");
      return;
    }

    const payload = {
      session_name: sessionName,
      session_type: "side",
      parent_session_id: sessionType === "child" ? selectedSideConvo : null,
      user_id: loginUserID,
      scratch_id: scratchPadId,
      custom_instructions: customInstructions,
    };
    setButtonDisable(true);

    fetch(`${apiUrl}/scratch_pad_session_create`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiToken}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((data) => {
        // Check for both 'success' and 'status: success' patterns
        if (data.success || data.status === "success") {
          const newSessionId = data.session_id;
          handleClose();
          setButtonDisable(false);
          
          // Automatically switch to the new session
          if (newSessionId) {
            Cookies.set("chat_session_id", newSessionId);
            if (onSessionCreated) {
              onSessionCreated(newSessionId);
            }
            window.location.reload();
          }
        } else {
          setError(data.message || "An error occurred");
          setButtonDisable(false);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setError("An error occurred while creating the topic");
        setButtonDisable(false);
      });
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="lg"
      backdrop="static"
    >
      <Modal.Header style={{ background: "#000", color: "#fff" }} closeButton closeVariant="white">
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group controlId="formSessionName">
          <Form.Label>Topic Name</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter topic name"
            value={sessionName}
            onChange={(e) => setSessionName(e.target.value)}
            isInvalid={!!error && !sessionName.trim()}
          />
          <Form.Control.Feedback type="invalid">
            {error && !sessionName.trim() ? error : ""}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group className="mt-2">
          <Form.Label>Topic Type</Form.Label>
          <Form.Control
            as="select"
            value={sessionType}
            onChange={(e) => setSessionType(e.target.value)}
          >
            <option value="side">Topic</option>
            <option value="child">Subtopic</option>
          </Form.Control>
        </Form.Group>
        {sessionType === "child" && (
          <Form.Group className="mt-2">
            <Form.Label>Topics</Form.Label>
            <Form.Control
              as="select"
              value={selectedSideConvo}
              onChange={(e) => setSelectedSideConvo(e.target.value)}
              isInvalid={
                !!error && sessionType === "child" && !selectedSideConvo
              }
            >
              <option value="">Select a Topic</option>
              {sideConvoList.map((convo) => (
                <option key={convo.id} value={convo.id}>
                  {convo.name}
                </option>
              ))}
            </Form.Control>
            <Form.Control.Feedback type="invalid">
              {error && sessionType === "child" && !selectedSideConvo
                ? error
                : ""}
            </Form.Control.Feedback>
          </Form.Group>
        )}
        <Form.Group className="mt-3" controlId="formCustomInstructions">
          <Form.Label>Custom Instructions</Form.Label>
          <div style={{ display: "flex", gap: "8px", alignItems: "flex-start" }}>
            <Form.Control
              as="textarea"
              rows={6}
              style={{ fontSize: "1.1rem", flex: 1 }}
              placeholder="Enter custom instructions"
              value={customInstructions}
              onChange={(e) => setCustomInstructions(e.target.value)}
            />
            <MicButton
              onTranscript={(text) => setCustomInstructions(prev => prev ? `${prev} ${text}` : text)}
              size="md"
            />
          </div>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          disabled={buttonDisable}
          onClick={handleClose}
        >
          Cancel
        </Button>
        <Button variant="dark" disabled={buttonDisable} onClick={handleSubmit}>
          {buttonDisable ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Creating...
            </>
          ) : (
            button
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ScratchPadSessionPopup;
